module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.f28ed2e4.ttf";